import React from "react";
import InputBase from "@material-ui/core/InputBase";
const Input = (props) => {
  const [input, setInput] = React.useState(props.state || "");
  React.useEffect(() => {
    setInput(props.state || "");
  }, [props.state]);
  return (
    <div
      style={{
        width: `${props.width}px`,
        height: `${props.height}px` || "28px",
        border: "1px solid #c4c4c4",
        marginTop: "9px",
        marginLeft:`${props.customService ? "10px" : "0px" }`
      }}
    >
      <InputBase
        inputProps={{
          "aria-label":"Control Value1",
          className: props.inputClassName || ""
        }}
        aria-label={"Control Value1"}
        style={{ width: `${props.width}px`}}
        value={input}
        // required={true}
        onChange={(e) => {
          setInput(e.target.value);
        }}
        onBlur={(e) =>
          props.handleInput
            ? props.handleInput(e.target.value, props.index)
            : props.handleInput1(e.target.value, props.name)
        }
      />
    </div>
  );
};

export default Input;
